export const useCatalogScope = ({ path, params }) => {
  let uriComposition = path.split('/');
  return {
    type: uriComposition[1],
    action: uriComposition[3],
    name: uriComposition[2],
    id: params.id,
  };
};
